module.exports = __webpack_public_path__ + "static/aus-silver-e05a85c2219025fca78a9b0db87f0a09.jpg";